import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
} from '@mui/material';
import { createRef, Key, RefAttributes, useEffect, useRef } from 'react';
import Cropper, { ReactCropperElement, ReactCropperProps } from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import Close from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

interface Props {
	image: {
		base64: any;
		name: string;
	} | null;
	isOpen: boolean;
	option?: any;
	handleCropper: any;
	propType?: string;
}

const ImageCroppers = (props: Props) => {
	const { image, isOpen = false, option, handleCropper, propType } = props;
	const { t } = useTranslation();
	const cropperRefs = useRef<(ReactCropperElement | null)[]>([]);
	console.log(option);
	useEffect(() => {
		cropperRefs.current = Array(option.length).fill(null);
	}, [option]);

	const onCrop = (type: string) => {
		if (type == 'submit') {
			const croppedBlobs: Blob[] = [];

			cropperRefs.current.forEach((cropper: any, index: any) => {
				if (cropper?.cropper) {
					cropper.cropper.getCroppedCanvas().toBlob((blob: any) => {
						if (blob) {
							const file = new File(
								[blob],
								`${image?.name || 'cropped'}_${index}`,
								{
									type: blob.type,
								}
							);
							croppedBlobs.push(file);

							console.log(croppedBlobs);

							if (croppedBlobs.length === option.length) {
								handleCropper(croppedBlobs, propType);
							}
						}
					});
				}
			});
		} else {
			handleCropper();
		}
	};

	return (
		<Dialog
			open={isOpen}
			onClose={() => onCrop('cancel')}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			maxWidth='xl'
			fullWidth
		>
			<DialogTitle variant='h6'>{t('common.cropper')}</DialogTitle>
			<IconButton
				aria-label='close'
				onClick={() => onCrop('cancel')}
				sx={{
					position: 'absolute',
					right: 8,
					top: 8,
					color: (theme) => theme.palette.grey[500],
				}}
			>
				<Close />
			</IconButton>
			<DialogContent
				sx={{
					paddingTop: 0,
					paddingBottom: 0,
					display: 'flex',
					justifyContent: 'space-between',
					padding: '20px',
					flexWrap: 'wrap',
				}}
			>
				{option.map((item: any, index: number) => (
					<Cropper
						key={index}
						ref={(el: ReactCropperElement | null) =>
							(cropperRefs.current[index] = el)
						}
						style={{ width: '45%', minHeight: '600px', marginBottom: '20px' }}
						src={image?.base64}
						{...item}
					/>
				))}
			</DialogContent>
			<DialogActions>
				<Button type='submit' onClick={() => onCrop('cancel')}>
					{t('button.cancel')}
				</Button>
				<Button
					type='submit'
					variant='contained'
					onClick={() => onCrop('submit')}
				>
					{t('button.confirm')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ImageCroppers;
